import { render, staticRenderFns } from "./imageInput.vue?vue&type=template&id=54bd5b90&scoped=true&"
import script from "./imageInput.vue?vue&type=script&lang=ts&"
export * from "./imageInput.vue?vue&type=script&lang=ts&"
import style0 from "./imageInput.vue?vue&type=style&index=0&id=54bd5b90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd5b90",
  null
  
)

export default component.exports